import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year3/Summer/FractionsB/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'FractionsB',
  field: 'Number',
  weeks: [1, 2],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(/* webpackChunkName: "Year3/Summer/FractionsB/1AddFractions" */ './1AddFractions')
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Summer/FractionsB/2SubtractFractions" */ './2SubtractFractions'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Summer/FractionsB/3PartitionTheWhole" */ './3PartitionTheWhole'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Summer/FractionsB/4UnitFractionsOfASetOfObjects" */ './4UnitFractionsOfASetOfObjects'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Summer/FractionsB/5NonUnitFractionsOfASetOfObjects" */ './5NonUnitFractionsOfASetOfObjects'
        )
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Summer/FractionsB/6ReasoningWithFractionsOfAnAmount" */ './6ReasoningWithFractionsOfAnAmount'
        )
    })
  ]
});
export default Block;
